import { configureStore } from "@reduxjs/toolkit";
import refreshTokenReducer from "./features/refreshToken/refreshToken";
import loginReducer from "./features/login/login";
import verifyPANReducer from "./features/verifyPAN/verifyPAN";
import hideBreadCrumbReducer from "./features/hideBreadCrumb/hideBreadCrumb";
import sharedResources from "./features/sharedResources/sharedResources";
import AuthMatrix from "./features/Settings/Authorization/index";
import entitiesReducer from "./features/Settings/Management/entities/index";
import holidaysReducer from "./features/holidays/index.js";
import servicesReducer from "./features/Settings/Management/Services/index";
import usersReducer from "./features/Settings/Management/Users/index";
import beneCreateAccountReducer from "./features/accounts/beneficiaryAccount/createAccount";
import beneViewAllAccReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import beneAllVerificationReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import ownerAllVerificationReducer from "./features/owner/ownerAllVerification/ownerAllVerification";
import beneTxnViewAccDataReducer from "./features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import beneTransactionAccountsReducer from "./features/beneficiary/beneTxnAccounts/beneTransactionAccounts";
import userSliceReducer from "./features/users/index";
import devicesSlice from "./features/devices/devices";
import getUserDetailsState from "./features/users/userDetails";
import bbpsAccountSlice from "./features/BBPS/index";
import landingpagestate from "./features/landingpagestate/landingpagestate";
import totp from "../redux/features/totp/totp.js";
import xpentraLogoutSlice from "./features/logout/logout.js";
import invoicesSlice from "./features/Settings/Management/Invoices/index.js";
import rolesSlice from "./features/Settings/Management/Roles/index.js";
import featuresSlice from "./features/Settings/Management/Features/index.js";
import byok from "./features/byok/byok.js";
import reminderTxnSlice from "./features/reminderTransaction/index.js";
import TestAuthMatrix from "./features/Settings/TestAuthMatrix/index.js";
import customCategoryReducer from "./features/customCategory/index.js";
import beneCreateAccountSlice from "./features/accounts/beneficiaryAccount/createAccount.js";
import multientitySlice from "./features/multientity/multientity.js";
import multiEntitySwitcherSlice from "./features/multiEntitySwitcher/multiEntitySwitcher.js";
import settingStatistics from "./features/Settings/Statistics/index.js";
import rolesReducer from "./features/Settings/Management/Roles/index.js";
import reimbursementRequest from "./features/reimbursementRequest/index.js";
import reimbursementTransaction from "./features/reimbursementTransaction/index.js";
import { injectStore } from "./globalInspector/axiosInstance";
import ReimburseAccount from "../redux/features/accounts/ReimburseAccount/index.js";
import fieldForceAccount from "../redux/features/accounts/fieldForceAccount/index.js";
import fieldForceRequest from "../redux/features/fieldForceRequest/index.js";
import fieldForceTransaction from "../redux/features/fieldForceTransaction/index.js";
import remitterAccountReducer from "../redux/features/accounts/remitterAccount/remitterAccount.js";
import beneficiaryAccountReducer from "./features/accounts/beneficiaryAccount/index.js";
import internalAccountReducer from "./features/accounts/internalAccount/index.js";
import beneficiaryTransactionsReducer from "./features/transactions/beneficiaryTransactions/index.js";
import internalTransactionsReducer from "./features/transactions/internalTransactions/index.js";
import scheduleBeneficiaryTransactionsReducer from "./features/transactions/scheduleBeneficiaryTransactions/index.js";
import scheduleInternalTransactionsReducer from "./features/transactions/scheduleInternalTransactions/index.js";

export const store = configureStore({
  reducer: {
    refreshToken: refreshTokenReducer,
    login: loginReducer,
    verify: verifyPANReducer,
    totp: totp,
    byok: byok,
    multientity: multientitySlice,
    hideBreadCrumb: hideBreadCrumbReducer,
    sharedResources: sharedResources,
    AuthMatrix: AuthMatrix,
    entities: entitiesReducer,
    users: usersReducer,
    services: servicesReducer,
    beneCreateAccount: beneCreateAccountReducer,
    beneAllVerification: beneAllVerificationReducer,
    beneViewAllAcc: beneViewAllAccReducer,
    beneTxnViewAccData: beneTxnViewAccDataReducer,
    // ReimbursementTxnViewAccData: ReimbursementTxnViewReducer,
    beneTransactionAccounts: beneTransactionAccountsReducer,
    ownerAllVerification: ownerAllVerificationReducer,
    user: userSliceReducer,
    getUserDetailsinfo: getUserDetailsState,
    devices: devicesSlice,
    bbpsAccountSlice: bbpsAccountSlice,
    landingpagestate: landingpagestate,
    xpentraLogoutSlice: xpentraLogoutSlice,
    invoicesSlice: invoicesSlice,
    rolesSlice: rolesSlice,
    featuresSlice: featuresSlice,
    holidays: holidaysReducer,
    reminderTxnSlice: reminderTxnSlice,
    customCategory: customCategoryReducer,
    beneCreateAccountSlice: beneCreateAccountSlice,
    TestAuthMatrix: TestAuthMatrix,
    multiEntitySwitcherSlice: multiEntitySwitcherSlice,
    settingStatistics: settingStatistics,
    roles: rolesReducer,
    reimbursementRequest: reimbursementRequest,
    reimbursementTransaction: reimbursementTransaction,
    ReimburseAccount: ReimburseAccount,
    fieldForceAccount: fieldForceAccount,
    fieldForceRequest: fieldForceRequest,
    fieldForceTransaction: fieldForceTransaction,
    remitterAccount: remitterAccountReducer,
    beneficiaryAccount: beneficiaryAccountReducer,
    internalAccount: internalAccountReducer,
    beneficiaryTransactions: beneficiaryTransactionsReducer,
    internalTransactions: internalTransactionsReducer,
    scheduleBeneficiaryTransactions: scheduleBeneficiaryTransactionsReducer,
    scheduleInternalTransactions: scheduleInternalTransactionsReducer,
  },
});

injectStore(store);
